import React, { useEffect } from 'react';
import { PageHeader, Tabs, List, Card } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

import * as IMI from '../../lib/ManiaFrameWork/js/mania';

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Forms',
  },
  {
    path: 'FormControl',
    breadcrumbName: 'FormControl',
  },
];

const data = [
  {
    title: 'number',
    data: '<input type="text" data-valid="number" />',
    message: '숫자만 입력 가능합니다.',
  },
  {
    title: 'digit',
    data: '<input type="text" data-valid="digit" />',
    message: '숫자만 입력 가능합니다.',
  },
  {
    title: 'equalTo',
    data: '<input type="text" data-valid="equalTo" />',
    message: '일치하지 않습니다.',
  },
  {
    title: 'enNumber',
    data: '<input type="text" data-valid="enNumber" />',
    message: '영문 및 숫자만 입력 가능합니다.',
  },
  {
    title: 'email',
    data: '<input type="text" data-valid="email" />',
    message: '이메일 형식으로 입력해주세요.',
  },
  {
    title: 'english',
    data: '<input type="text" data-valid="english" />',
    message: '영문만 입력 가능합니다.',
  },
];
const Form_Control = () => {
  useEffect(() => document.querySelectorAll('[data-rule="formControl"]').forEach((el) => new IMI.FormControl(el)), []);
  return (
    <>
      <PageHeader title="FormControl" breadcrumb={{ routes }} subTitle="FormControl" style={{ padding: 10 }} />
      <div className="MF_area">
        <form data-rule="formControl" method="post">
          <input type="text" className="input_text mg_b_5" name="user_name" placeholder="name" required data-valid="digit" />
          <input type="text" className="input_text mg_b_5" name="user_id" placeholder="id" />
          <button type="submit" className="btn btn_fill_blue" value="Submit">Submit</button>
        </form>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<form data-rule="formControl" method="post">
  <input type="text" class="input_text" name="user_name" placeholder="name" required data-valid="digit" />
  <input type="text" class="input_text" name="user_id" placeholder="id" />
  <button type="submit" class="btn btn_fill_blue" value="Submit">Submit</button>
</form>`}
            </CodeHighlight>
          </TabPane>
          <TabPane tab="JAVASCRIPT" key="2">
            <CodeHighlight language="JS">
              {`var formControls = document.querySelectorAll('[data-rule="formControl"]');
for (var i = 0; i < formControls.length; i++){ new FormControl(formControls[i]) }`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
      <h3 style={{ margin: '16px 0' }}>Options</h3>
      <List
        grid={{
          gutter: 16,
          xs: 1,
          sm: 1,
          md: 1,
          lg: 2,
          xl: 3,
          xxl: 3,
        }}
        dataSource={data}
        renderItem={item => (
          <List.Item>
            <Card title={item.title}>
              <CodeHighlight language="HTML">
                {item.data}
              </CodeHighlight>
              <b>Alert message</b> <br />{item.message}
            </Card>
          </List.Item>
        )}
      />
    </>
  );
}

export default Form_Control;
